import { createStore } from 'vuex'

// Modules import
import Authentication from './authentication'
import Notifications from './notifications'
import User from './user'

const state = {}
const actions = ({})
const mutations = ({})
const getters = ({})

const modules = {
  authentication: Authentication,
  user: User,
  notifications: Notifications,
}

export default createStore({
  state,
  actions,
  mutations,
  getters,
  modules
})
